<template>
	<div class="app--engagement-groups page-content">
		<div class="app--engagement-group">
			<div class="group-content bg--group border--group">
				<div class="app--engagement-cfs-report" v-show="content" v-html="content"></div>
			</div>
		</div>
	</div>
</template>

<script>
import store from '../../store'

export default {
	computed: {
		content() {
			let report = store.state.elements.find(e => {
				return e.definition == store.getters['customElement']('cfs_report').id
			})
			return (report && report.value) ? report.value : ''
		},
	}
}
</script>
